define('views/HeaderView',[
    'backbone',
    'lodash',
    'text!templates/header.html',
    'text!templates/counter.html',
    'app'
], function (Backbone, _, headerTmpl, counterTmpl, App) {

    "use strict";

    return Backbone.View.extend({

        tagName: 'header',

        template: _.template(headerTmpl),

        counterTmpl: _.template(counterTmpl),

        events: {
            'mousedown .toggle': 'toggle',
            'click nav a': 'toggle'
        },

        initialize: function () {
            this.$el.html(this.template(App));

            // preload numbers.svg
            var img = new Image();
            img.onload = function () {};
            img.src = App.asset('img/numbers.svg');
        },

        highlight: function (fragment) {
            var href = App.route(fragment),
                active = this.$el.find('nav .active'),
                target = this.$el.find('nav [href="' + href + '"]');
            active.removeClass('active');
            active.siblings('.counter').remove();

            if (target.length) {
                target.addClass('active');
                this.countTo(target, target.parent().index());
            }
        },

        countTo: function (el, digit) {
            var dist = Math.ceil(Math.random()*8),
                start = digit >= dist ? digit - dist : digit + (10 - dist),
                $counter = $(this.counterTmpl({
                    start: start,
                    end: digit,
                    digit: App.blocks.digit
                }));

            $(el).before($counter);
        },

        toggle: function () {
            this.$el.toggleClass('show');
            if (this.$el.hasClass('show')) {
                App.view.noScroll();
            } else {
                App.view.enableScroll();
            }
        }
        
    });

});
